import React from "react";
import {
  Box,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  Text,
  Image,
  Tooltip,
} from "@chakra-ui/react";
import {
  UserCircleIcon,
  BellIcon,
  ArrowRightOnRectangleIcon,
  ArrowLeftOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { HiOutlineSun, HiOutlineMoon } from "react-icons/hi2";
import Logo from "./Images/stande-classroom-logo.png";
import { c, PALETTES } from "./classroomColors";

const Header = ({ handleLogout, isDark, onToggleColorMode }) => {
  // Menus render in a portal outside the theme wrapper, so use literal values.
  const p = isDark ? PALETTES.dark : PALETTES.light;
  const menuListProps = {
    bg: p.surface,
    color: p.text,
    border: "1px solid",
    borderColor: p.border,
    borderRadius: "10px",
    boxShadow: "0 12px 30px -12px rgba(0,0,0,0.4)",
    py: "6px",
  };
  const menuItemProps = {
    bg: "transparent",
    color: p.text,
    fontSize: "14px",
    _hover: { bg: p.hover },
    _focus: { bg: p.hover },
  };
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px="0"
      py="16px"
      w="100%"
    >
      <Image src={Logo} alt="Stande Logo" h="32px" display="block" />

      <HStack spacing="14px">
        {onToggleColorMode && (
          <Tooltip label={isDark ? "Light mode" : "Dark mode"} placement="bottom" hasArrow>
            <Box
              as="button"
              aria-label="Toggle dark mode"
              bg={c.hover}
              borderRadius="50%"
              w="42px"
              h="42px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              onClick={onToggleColorMode}
            >
              <Icon as={isDark ? HiOutlineSun : HiOutlineMoon} w="18px" h="18px" color={c.text} />
            </Box>
          </Tooltip>
        )}

        <Menu>
          <MenuButton as={Button} variant="unstyled" p={0}>
            <Box
              bg={c.hover}
              borderRadius="50%"
              w="42px"
              h="42px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={BellIcon} w="18px" h="18px" color={c.textSub} />
            </Box>
          </MenuButton>
          <MenuList {...menuListProps}>
            <MenuItem {...menuItemProps} cursor="default">
              <Text color={p.textMuted} fontSize="sm">
                No notifications yet
              </Text>
            </MenuItem>
          </MenuList>
        </Menu>

        <Menu>
          <MenuButton as={Button} variant="unstyled" p={0}>
            <Box
              bg={c.hover}
              borderRadius="50%"
              w="42px"
              h="42px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={UserCircleIcon} w="18px" h="18px" color={c.textSub} />
            </Box>
          </MenuButton>
          <MenuList {...menuListProps}>
            <MenuItem
              {...menuItemProps}
              icon={
                <Icon
                  as={ArrowLeftOnRectangleIcon}
                  w="20px"
                  h="20px"
                  color={p.textSub}
                />
              }
              onClick={() => window.location.href = "/dashboard"}
            >
              Back to Stande
            </MenuItem>
            <MenuItem
              {...menuItemProps}
              icon={
                <Icon
                  as={ArrowRightOnRectangleIcon}
                  w="20px"
                  h="20px"
                  color={p.textSub}
                />
              }
              onClick={handleLogout}
            >
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
      </HStack>
    </Box>
  );
};

export default Header;


